import { type GetterTree } from 'vuex';

import { type ISharedFieldCustomValueState } from './types';

export const GET_FROM_LIST_ID = 'GET_FROM_LIST_ID';

export const getters: GetterTree<ISharedFieldCustomValueState, unknown> = {
    [GET_FROM_LIST_ID]: (_state: ISharedFieldCustomValueState) => {
        return (listId: number): number[] => {
            return _state.byListId.get(listId);
        };
    }
};
